import {
  documentTypeCode,
  messages,
  studyModeForNonContractClasses,
  status,
  studentStatusCode,
  studentStatus,
  GoogleAnalyticsScript,
  DocumentStatus,
  DocumentType,
  studentApplicationSubStatus
} from 'src/context/common'
import { IDynamicObject, IInputListTypes, IScheduleAPITypes, IScheduleDuration } from 'src/context/types'
import { IFileInterface, commonListTypes, documentTypes } from 'src/types/dataTypes'
import moment from 'moment'
import { IAddressStateTypes, IAddressTypes } from 'src/types/apps/admittedStudent'
import { CommonService } from 'src/service'
import { Dispatch, SetStateAction } from 'react'
import { errorToast } from 'src/@core/components/common/Toast'
import nProgress from 'nprogress'
import axios from 'axios'
import { IIntakeCommonLists } from 'src/types/invoiceTypes'
import { Box, LinearProgress, LinearProgressProps, Typography } from '@mui/material'

export const getQualificationName = (qualificationList: Array<commonListTypes>, qualificationCode: string) => {
  let result = ''

  if (qualificationList?.length) {
    const response = qualificationList.find((item: commonListTypes) => item.code === qualificationCode)
    result = response?.name || ''
  }

  return result
}

export const getProgramName = (programList: Array<commonListTypes>, programCode: string) => {
  let result = ''

  if (programList?.length) {
    const response = programList.find((item: commonListTypes) => item.code === programCode)
    result = response?.name || ''
  }

  return result
}

export const getAddressName = (programList: Array<commonListTypes>, programCode: string) => {
  let result = ''

  if (programList?.length) {
    const response = programList.find((item: commonListTypes) => item.code === programCode)
    result = response?.name || ''
  }

  return result
}

const headers = [
  { label: '#', key: 'serialNumber' },
  { label: 'Student ID', key: 'studentCode' },
  { label: 'StudentDetails', key: 'fullName' },
  { label: 'Email', key: 'email' },
  { label: 'Race', key: 'race' },
  { label: 'Gender', key: 'gender' },
  { label: 'Study Mode', key: 'studyMode' },
  { label: 'Student Type', key: 'studentTypeCode' },
  { label: 'Identification Number', key: 'nationalId' },
  { label: 'Contact', key: 'mobileNumberDetail' },
  { label: 'Qualification Details', key: 'educationDetails' },
  { label: 'StudyMode', key: 'studyModeName' },
  { label: 'Intake', key: 'intake' },
  { label: 'Status', key: 'status' }
]
export const arrayToCsv = (data: any) => {
  const csvRows = []
  const headerValues = headers.map(header => header.label)
  csvRows.push(headerValues.join(','))
  for (const row of data) {
    const rowValues = headers.map(header => {
      return `"${row[header.key]}"`
    })
    csvRows.push(rowValues.join(','))
  }

  return csvRows.join('\n')
}

export const arrayToCsvGraduate = (headers: any, data: any) => {
  const csvRows = []
  const headerValues = headers.map((header: { label: any }) => header.label)
  csvRows.push(headerValues.join(','))

  for (const row of data) {
    const rowValues = headers.map((header: { key: string | number }) => {
      return `"${row[header.key]}"`
    })
    csvRows.push(rowValues.join(','))
  }

  return csvRows.join('\n')
}
export const download = (data: any, fileName: string) => {
  const blob = new Blob([data], { type: 'text/csv' })
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.setAttribute('hidden', '')
  a.setAttribute('href', url)
  a.setAttribute('download', fileName + '.csv')
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

export const arrayToCsvInAttendance = (headers: any, data: any) => {
  const csvRows = []
  const headerValues = headers.map((header: { label: any }) => header.label)
  csvRows.push(headerValues.join(','))

  for (const row of data) {
    const rowValues = headers.map((header: { key: string | number }) => {
      return `"${row[header.key]}"`
    })
    csvRows.push(rowValues.join(','))
  }

  return csvRows.join('\n')
}

export const checkDocumentType = (row: string) => {
  if (row === DocumentStatus.OPERATION_APPROVED) {
    return false
  }

  return true
}

export const filteredDocListArray = (documentTypeList: any) => {
  return documentTypeList?.filter(
    (item: any) =>
      item.code === DocumentType.SAQA_certificate ||
      item.code === DocumentType.Matriculation_Board_Certificate ||
      item.code === DocumentType.AC_Form ||
      item.code === DocumentType.Marriage_Certificate ||
      item.code === DocumentType.Updated_ID_for_Change_of_Names ||
      item.code === DocumentType?.Completion_Plan ||
      item.code === DocumentType?.Exemption_Form ||
      item.code === DocumentType?.AOD_Agreement ||
      item.code === DocumentType.IDPassport ||
      item.code === DocumentType.ResumeCV ||
      item.code === DocumentType.HighestQualification ||
      item.code === DocumentType.DeclarationForm ||
      item.code === DocumentType.MotivationLetter ||
      item.code === DocumentType.InterviewNotes ||
      item.code === DocumentType.MatricCertificate ||
      item.code === DocumentType.ApplicationLetter ||
      item.code === DocumentType.Others ||
      item.code === DocumentType.EdForAllContract ||
      item.code === DocumentType.DebitOrder ||
      item.code === DocumentType.Study_Flexi_Agreement ||
      item.code === DocumentType.Study_Flexi_Calculation
  )
}

export const dateFormat = (currentDateTime: any) => {
  const formattedDate = currentDateTime?.toLocaleDateString(undefined, {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  })
  const newFormattedDate = formattedDate.replace(',', '')
  const [month, day, year] = newFormattedDate.split(' ')
  const formatMonthFormate = `${day} ${month} ${year}`

  return `${formatMonthFormate}`
}

export const DDMMYYYDateFormat = (date: Date) => {
  const newDate = new Date(date)

  return `${newDate.getDate()}/${newDate.getMonth() + 1}/${newDate.getFullYear()}`
}

export const DDMMYYYDateFormatExport = (date: Date) => {
  const newDate = new Date(date)

  const day = String(newDate.getDate()).padStart(2, '0')
  const month = String(newDate.getMonth() + 1).padStart(2, '0')
  const year = newDate.getFullYear()

  return `${day}${month}${year}`
}

export const getStudyType = (studyTypeList: Array<commonListTypes>, studyTypeCode: string) => {
  let result = ''
  if (studyTypeList?.length > 0) {
    const response = studyTypeList.find(item => item.code === studyTypeCode)
    result = response?.name || ''
  }

  return result
}

export const getSelectedDocument = (selectedDocument: Array<string | number>, documentList: Array<documentTypes>) => {
  const result: Array<documentTypes> = []
  selectedDocument?.forEach((documentId: string | number) => {
    documentList.find((item: documentTypes) => {
      if (item?.id === documentId) {
        result.push(item)
      }
    })
  })

  return result
}

export const ProgramCodeIntakeCodeUpdatedFn = (schedule: any, data: any) => {
  const tempUg: any[] = Object?.entries(schedule?.orientationScheduleQualifications?.UG?.programs || []).map(
    ([qualificationCode, data]: any) => ({
      qualificationCode: qualificationCode,
      intakes: Object.values(data?.intakes || []).map((intake: any) => ({
        intakeCode: intake?.id
      }))
    })
  )

  const tempPg: any[] = Object?.entries(schedule?.orientationScheduleQualifications?.PG?.programs || []).map(
    ([qualificationCode, data]: any) => ({
      qualificationCode: qualificationCode,
      intakes: Object.values(data?.intakes || []).map((intake: any) => ({
        intakeCode: intake?.id
      }))
    })
  )

  const tempPgDetailsRows = data?.pgDetailsRows?.map(
    (item: { intakeOptions: any; pgQualification: any; pgIntakes: any[] }) => ({
      qualificationCode: item.pgQualification,
      intakes: item.pgIntakes.map(intakeId => {
        const match = item.intakeOptions?.find((opt: { id: any }) => opt.id === intakeId)

        return {
          intakeCode: intakeId,
          code: match?.code ?? null
        }
      })
    })
  )

  const tempUgDetailsRows = data?.ugDetailsRows?.map(
    (item: { intakeOptions: any; ugProgram: any; ugIntakes: any[] }) => ({
      qualificationCode: item.ugProgram,
      intakes: item.ugIntakes.map(intakeId => {
        const match = item.intakeOptions?.find((opt: { id: any }) => opt.id === intakeId)

        return {
          intakeCode: intakeId,
          code: match?.code ?? null
        }
      })
    })
  )

  const updatedProgramCodes: any[] = []
  const updatedIntakeCodes: any[] = []

  tempPgDetailsRows.forEach((item: { qualificationCode: any; intakes: any[] }) => {
    const match = tempPg.find(s => s.qualificationCode === item.qualificationCode)

    if (!match) {
      updatedProgramCodes.push(item.qualificationCode)
      updatedIntakeCodes.push(...item.intakes.map(intk => intk.code))
    } else {
      const matchIntakes = match.intakes.map((i: { intakeCode: any }) => i.intakeCode)
      let missingFound = false

      item.intakes.forEach(intk => {
        if (!matchIntakes.includes(intk.intakeCode)) {
          updatedIntakeCodes.push(intk.code)
          missingFound = true
        }
      })

      if (missingFound) {
        updatedProgramCodes.push(item.qualificationCode)
      }
    }
  })

  tempUgDetailsRows.forEach((item: { qualificationCode: any; intakes: any[] }) => {
    const match = tempUg.find(s => s.qualificationCode === item.qualificationCode)

    if (!match) {
      updatedProgramCodes.push(item.qualificationCode)
      updatedIntakeCodes.push(...item.intakes.map(intk => intk.code))
    } else {
      const matchIntakes = match.intakes.map((i: { intakeCode: any }) => i.intakeCode)
      let missingFound = false

      item.intakes.forEach(intk => {
        if (!matchIntakes.includes(intk.intakeCode)) {
          updatedIntakeCodes.push(intk.code)
          missingFound = true
        }
      })

      if (missingFound) {
        updatedProgramCodes.push(item.qualificationCode)
      }
    }
  })

  return { updatedProgramCodes: updatedProgramCodes.join(','), updatedIntakeCodes: updatedIntakeCodes.join(',') }
}

export const updatedGetSelectedDocument = (
  selectedDocument: Array<string | number>,
  documentList: Array<any>,
  setotherthandebitornot?: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const result: Array<any> = []
  let ifotherthandebitorderornot = false
  selectedDocument?.forEach((documentId: string | number) => {
    documentList?.find(item => {
      if (item?.id === documentId) {
        result.push(item)
        ifotherthandebitorderornot = ifotherthandebitorderornot || item.documentTypeCode != documentTypeCode.debitorder
      }
    })
  })
  if (setotherthandebitornot) {
    setotherthandebitornot(ifotherthandebitorderornot)
  }

  return result
}
export const downloadFile = (url: any, fileName: string) => {
  const fileUrl = url?.split('?')
  const data = fileUrl[0]
  const ext = data.split('.').pop()

  axios
    .get(url, {
      responseType: 'arraybuffer'
    })
    .then(response => {
      const file = new Blob([response.data], {
        type:
          ext === 'pdf'
            ? 'application/pdf'
            : ext === 'xls'
            ? 'application/xls'
            : ext === 'xlsx'
            ? 'application/xlsx'
            : 'image/jpeg'
      })
      const fileURL = URL.createObjectURL(file)
      const aElement = document.createElement('a')
      aElement.setAttribute('download', fileName)
      const href = fileURL
      aElement.href = href
      aElement.setAttribute('target', '_blank')
      aElement.click()
      URL.revokeObjectURL(href)
    })
    .catch(error => {
      console.log('Error viewing file', error.message)
    })
}
export const checkContractNonContractClasses = (
  acceptanceLatter: IFileInterface,
  confirmationLatter: IFileInterface,
  nonAacceptanceLatter: IFileInterface,
  nonConfirmationLatter: IFileInterface,
  studyModeSelected: string[]
) => {
  if (studyModeSelected?.includes(studyModeForNonContractClasses?.Online) && studyModeSelected.length > 1) {
    return acceptanceLatter?.name &&
      confirmationLatter?.name &&
      nonAacceptanceLatter?.name &&
      nonConfirmationLatter?.name
      ? false
      : true
  } else if (studyModeSelected?.includes(studyModeForNonContractClasses?.Online) && studyModeSelected?.length === 1) {
    return nonAacceptanceLatter?.name && nonConfirmationLatter?.name ? false : true
  } else if (studyModeSelected?.length > 0 && !studyModeSelected?.includes(studyModeForNonContractClasses?.Online)) {
    return acceptanceLatter?.name && confirmationLatter?.name ? false : true
  } else {
    return false
  }
}

export const statusOnCommentToBeRequired = [
  'DEFERRED',
  'FEES_PENDING',
  'MOVING_AWAY',
  'FAMILY_REASONS',
  'MOVED_TO_ANOTHER_QUALIFICATION',
  'CANC_OTHER',
  'GENERAL'
]

export const fileConvertToPayload = (
  acceptanceLatter: IFileInterface,
  confirmationLatter: IFileInterface,
  nonAacceptanceLatter: IFileInterface,
  nonConfirmationLatter: IFileInterface
) => {
  const result = []
  if (acceptanceLatter) {
    result.push({
      fileName: acceptanceLatter?.name,
      fileType: '.docx',
      isContactClass: true,
      documentTypeCode: documentTypeCode?.acceptance
    })
  }
  if (confirmationLatter) {
    result.push({
      fileName: confirmationLatter?.name,
      fileType: '.docx',
      isContactClass: true,
      documentTypeCode: documentTypeCode?.confirmation
    })
  }
  if (nonAacceptanceLatter) {
    result.push({
      fileName: nonAacceptanceLatter?.name,
      fileType: '.docx',
      isContactClass: false,
      documentTypeCode: documentTypeCode?.acceptance
    })
  }
  if (nonConfirmationLatter) {
    result.push({
      fileName: nonConfirmationLatter?.name,
      fileType: '.docx',
      isContactClass: false,
      documentTypeCode: documentTypeCode?.confirmation
    })
  }

  return result
}

export function LinearProgressWithLabel(props: LinearProgressProps & { value: number }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant='determinate' {...props} color='primary' />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant='body2' color='text.primary'>{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  )
}

export const acceptanceLatterUpload = (
  acceptanceLatter: IFileInterface,
  confirmationLatter: IFileInterface,
  nonAacceptanceLatter: IFileInterface,
  nonConfirmationLatter: IFileInterface
) => {
  const result = []
  if (acceptanceLatter?.file) {
    result.push({
      fileName: acceptanceLatter?.name,
      fileType: '.docx',
      file: acceptanceLatter?.file
    })
  }
  if (confirmationLatter?.file) {
    result.push({
      fileName: confirmationLatter?.name,
      fileType: '.docx',
      file: confirmationLatter?.file
    })
  }
  if (nonAacceptanceLatter?.file) {
    result.push({
      fileName: nonAacceptanceLatter?.name,
      fileType: '.docx',
      file: nonAacceptanceLatter?.file
    })
  }
  if (nonConfirmationLatter?.file) {
    result.push({
      fileName: nonConfirmationLatter?.name,
      fileType: '.docx',
      file: nonConfirmationLatter?.file
    })
  }

  return result
}

export const getName = (list: Array<IDynamicObject>, code: string) => {
  if (list?.length > 0) {
    return list?.find(item => item.code === code)?.name ?? code
  }

  return code
}
export const getNameById = (list: Array<commonListTypes>, id: number | string) => {
  if (list?.length > 0) {
    return list?.find(item => item.id === id)?.name ?? id
  }

  return id
}

export const serialNumber = (params: number, pageNumber: number, pageSize: number) => {
  return pageNumber === 1 ? params + 1 : (pageNumber - 1) * pageSize + (params + 1)
}

export const findValue = (array: any, value: string | number, serchBases: string | null) => {
  let returnValue = null

  if (serchBases != null) {
    returnValue = array?.find((item: any) => {
      return item[serchBases] === value
    })
  } else {
    returnValue = array?.find((item: any) => {
      return item === value
    })
  }

  return returnValue
}

export const DateFormat = (date: Date) => {
  const newDate: Date = new Date(date)
  const weekday: Array<number | string> = new Array(7)
  weekday[0] = 'SUN'
  weekday[1] = 'MON'
  weekday[2] = 'TUE'
  weekday[3] = 'WED'
  weekday[4] = 'THU'
  weekday[5] = 'FRI'
  weekday[6] = 'SAT'
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']

  const formateDate = {
    date: `${newDate.getDate()} ${monthNames[newDate.getMonth()]} ${newDate.getFullYear()}`,
    weekName: weekday[newDate.getDay()]
  }

  return formateDate
}

export const DateFormatt = (date: Date) => {
  const newDate = new Date(date)

  return `${minTwoDigits(newDate.getDate())}/${minTwoDigits(newDate?.getMonth() + 1)}/${newDate.getFullYear()}`
}

export const formateDate = (item: any) => {
  const today = new Date(item)
  const yyyy = today.getFullYear()
  let mm: any = today.getMonth() + 1 // Months start at 0!
  let dd: any = today.getDate()

  if (dd < 10) dd = '0' + dd
  if (mm < 10) mm = '0' + mm

  const formattedDate = yyyy + '-' + mm + '-' + dd

  return formattedDate
}

export const selectedDate = (dates: string[]) => {
  const result: any = []

  if (dates?.length) {
    if (dates.length > 6) {
      dates.pop()
    }
    dates.forEach(item => {
      result.push(new Date(item))
    })

    return result
  }
}

export const scheduleListTimer = (data: IScheduleAPITypes) => {
  const result: Array<IInputListTypes> = []

  if (data?.scheduleDuration?.length) {
    data?.scheduleDuration?.forEach((element: IScheduleDuration, index: number) => {
      const date = element?.date?.filter((items: string | Date) => formateDate(items))
      const start = moment().format(`YYYY-MM-DD ${element?.from}`)
      const end = moment().format(`YYYY-MM-DD ${element?.to}`)
      result.push({ id: index + 1, dates: date, startTime: new Date(start), endTime: new Date(end) })
    })
  }

  return result
}

export function generateCodeVerifier() {
  const array = new Uint32Array(56 / 2)
  window.crypto.getRandomValues(array)

  return Array.from(array, dec => ('0' + dec.toString(16)).substr(-2)).join('')
}

export async function generateCodeChallenge(codeVerifier: any) {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(codeVerifier))

  return btoa(String.fromCharCode(...new Uint8Array(digest)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '')
}

const DateFormatUpdated = (date: moment.Moment) => {
  return {
    date: date.format('Do MMM YYYY'),
    weekName: date.format('ddd')
  }
}

export const scheduleDateFormateUpdated = (date: string | Date) => {
  const utcDate = moment.utc(date)

  return DateFormatUpdated(utcDate)
}

export const getStateName = (list: Array<IAddressStateTypes> = [], code: string) =>
  list?.length > 0 ? list?.find(state => state.isoCode === code)?.name ?? code : code

export const getSymbol = (list: Array<commonListTypes>, code: string) => {
  if (list?.length > 0) {
    return list?.find(item => item.code === code)?.symbol ?? code
  }

  return code
}

export const getStateList = async (countryCode: string): Promise<Array<IAddressStateTypes>> => {
  const response = await CommonService.getStatesByCountry(countryCode)
  if (status.successCodeArr.includes(response?.statusCode) && !!response?.data) {
    return response?.data
  } else {
    return []
  }
}

export const fetchStateList = async (addresses: IAddressTypes[]) => {
  const addressPromise = addresses?.map(async address => {
    const stateName = getStateName(await getStateList(address.country), address.state)

    return { ...address, stateName }
  })

  try {
    const addressData = await Promise.all(addressPromise)
    addressData?.sort((firstElement, secondElement) =>
      firstElement?.addressType?.localeCompare(secondElement?.addressType)
    )

    return addressData
  } catch (error) {
    console.error(messages.error, error)
  }
}

export const ordinalSuffixOf = (i: number) => {
  const j = i % 10,
    k = i % 100
  if (j == 1 && k != 11) {
    return i + 'st'
  }
  if (j == 2 && k != 12) {
    return i + 'nd'
  }
  if (j == 3 && k != 13) {
    return i + 'rd'
  }

  return i + 'th'
}

export const minTwoDigits = (n: number) => {
  return (n < 10 ? '0' : '') + n
}

export function getFullName(firstName: string, lastName: string) {
  const fullName = `${firstName.charAt(0).toUpperCase() + firstName.slice(1)} ${
    lastName.charAt(0).toUpperCase() + lastName.slice(1)
  }`

  return fullName
}

export const getStudyModeName = (studyModeList: Array<commonListTypes>, studyModeCode: string) => {
  return studyModeList.length > 0 ? studyModeList?.find(item => item.code === studyModeCode)?.name : studyModeCode
}

export const calculateFileSize = (size: number) => {
  return size > 1024
    ? size / 1024 > 1024
      ? `${(size / 1024 / 1024).toFixed(2)} MB`
      : `${Math.round(size / 1024)} KB`
    : `${size} KB`
}

export const DDMMYYDateFormate = (date: Date) => {
  const newDate: Date = new Date(date)
  const weekday: Array<number | string> = new Array(7)
  weekday[0] = 'Sunday'
  weekday[1] = 'Monday'
  weekday[2] = 'Tuesday'
  weekday[3] = 'Wednesday'
  weekday[4] = 'Thursday'
  weekday[5] = 'Friday'
  weekday[6] = 'Saturday'
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]

  const formateDate = {
    date: `${weekday[newDate.getDay()]}, ${minTwoDigits(newDate.getDate())}  ${monthNames[newDate.getMonth()]} `
  }

  return formateDate
}
export const viewProofDetails = (
  url: string,
  setViewFileLoader?: Dispatch<SetStateAction<{ [key: string]: boolean } | undefined>>,
  fileCode?: string
) => {
  const fileUrl = url.split('?')
  const data = fileUrl[0]
  const ext = data.split('.').pop()
  nProgress.start()
  axios
    .get(url, {
      responseType: 'arraybuffer'
    })
    .then(response => {
      const file = new Blob([response.data], {
        type: ext === 'pdf' ? 'application/pdf' : 'image/jpeg'
      })
      !!setViewFileLoader && !!fileCode && setViewFileLoader(prev => ({ ...prev, [fileCode]: false }))
      const fileURL = URL.createObjectURL(file)
      window.open(fileURL)
    })
    .catch(error => {
      errorToast(`Error viewing file ${error.message}`)
    })
    .finally(() => {
      nProgress.done()
      !!setViewFileLoader && !!fileCode && setViewFileLoader(prev => ({ ...prev, [fileCode]: false }))
    })
}
export const getFileUrl = async (
  fileName: string,
  studentCode: string,
  setViewFileLoader?: Dispatch<SetStateAction<{ [key: string]: boolean } | undefined>>,
  fileCode?: string
) => {
  const response = await CommonService.getFileUrl(fileName, studentCode)
  if (response?.data?.statusCode === status?.successCode) {
    viewProofDetails(response?.data?.data, setViewFileLoader, fileCode)
  } else {
    !!setViewFileLoader && !!fileCode && setViewFileLoader(prev => ({ ...prev, [fileCode]: false }))
    errorToast('Error viewing file')
  }
}

export const getStatusByDate = (date: Date, timeFrom: string, timeTo: string) => {
  const today = new Date()

  const [fromHour, fromMinute] = timeFrom.split(':').map(Number)
  const [toHour, toMinute] = timeTo.split(':').map(Number)

  const startDateTime = new Date(date)
  startDateTime.setHours(fromHour, fromMinute, 0, 0)

  const endDateTime = new Date(date)
  endDateTime.setHours(toHour, toMinute, 0, 0)

  if (today < startDateTime) {
    return 'Upcoming'
  } else if (today > endDateTime) {
    return 'Completed'
  } else {
    return 'Ongoing'
  }
}

export const getTimeFormate = (time: string) => {
  const formattedTime = time.slice(0, 5)

  return formattedTime
}

export const getTime = (isoString: string | Date) => {
  return moment(isoString).local().format('HH:mm')
}

export const checkResponseIfSuccess = (response: any) => {
  let result = null
  if (response?.data?.statusCode === status?.successCode && response?.data?.data) {
    result = response?.data?.data
  }

  return result
}
export const filterNameByCode = (data: any, code: string) => {
  let name = code
  if (data?.length && code) {
    const filterObj = data?.find((item: IIntakeCommonLists) => item?.code === code)
    name = filterObj?.name ? filterObj?.name : code
  }

  return name
}
export const convertToRegularFormat = (inputString: string) => {
  return inputString?.charAt(0)?.toUpperCase() + inputString?.slice(1)?.toLowerCase()
}

export function formatDateDashedFormat(inputDateString: string) {
  const date = new Date(inputDateString)

  const day = date.getDate().toString().padStart(2, '0')
  const monthAbbreviation = date.toLocaleString('en-US', { month: 'short' }).toUpperCase()
  const year = date.getFullYear()

  return `${day}-${monthAbbreviation}-${year}`
}

export const getQueryName = (list: Array<commonListTypes>, code: string) => {
  if (list?.length > 0) {
    return list?.find(item => item.code === code)?.name ?? code
  }

  return code
}

export const monthsName = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
]

// january to December colors
export const monthsColors = [
  '#fc6b6a',
  '#81d5fa',
  '#c7f465',
  '#4ecdc4',
  '#546f7a',
  '#fc6b6a',
  '#81d5fa',
  '#c7f465',
  '#4ecdc4',
  '#546f7a',
  '#fc6b6a',
  '#81d5fa'
]

export const studyModeColors = ['#ffe700', '#00d4bd', '#826bf9', '#ffa1a1']
export const studyModes = ['SeptemberIntake', 'DecIntake', 'MarIntake', 'AprilIntake', 'JulyIntake']

export const showIcon = (VIPType: string) => {
  if (VIPType === 'VIP') {
    return Array.from({ length: 1 })
  } else if (VIPType === 'VVIP') {
    return Array.from({ length: 2 })
  } else {
    return Array.from({ length: 3 })
  }
}

export const getStudentStatus = (status: string) => {
  switch (true) {
    case studentStatusCode.pending.includes(status):
      return studentStatus.pending
    case studentStatusCode.rejects.includes(status):
      return studentStatus.reject
    case studentStatusCode.approval.includes(status):
      return studentStatus.approved
    case studentStatusCode.managementCode.includes(status):
      return studentStatus.admitted
    default:
      return status
  }
}

export const checkProd = () => {
  if (process.env.NEXT_PUBLIC_USER_REDIRECT_URL === GoogleAnalyticsScript.prodURL) return true
  else return false
}

export const getFirstAndLastDateOFTheYear = (year: number) => {
  const currentDate = new Date()
  const EndDate = new Date(new Date(new Date().getFullYear(), 11, 31).setFullYear(year))
  const firstDateOfYear = new Date(new Date(currentDate.getFullYear(), 0, 1).setFullYear(year))

  return { endDate: EndDate, firstDate: firstDateOfYear }
}

export const capitalizeFirstLetter = (str: string | any) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const compareDates = (date1: Date, date2: Date): number => {
  // Convert both dates to milliseconds since epoch
  const time1 = date1.getTime()
  const time2 = date2.getTime()

  // Compare the milliseconds
  if (time1 < time2) {
    return -1
  } else if (time1 > time2) {
    return 1
  } else {
    return 0
  }
}

export function IsJsonString(str: any) {
  try {
    const json = JSON.parse(str)

    return typeof json === 'object'
  } catch (e) {
    return false
  }
}

export function roundToTwoDecimalPlaces(value: unknown): string {
  if (value === '-' || value === null || value === undefined) return '-'

  const num = Number(value)
  if (isNaN(num)) return '-'

  return Number.isInteger(num) ? num.toString() : num.toFixed(2)
}

export const trimTotal = (num: number) => {
  const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
  const formattedNumber = formatter.format(num)

  return formattedNumber
}

export const isWithinThreeDays = (scheduleDateTime: string | Date): boolean => {
  const currentDateTime = new Date()
  const threeDaysFromNow = new Date(currentDateTime)
  threeDaysFromNow.setDate(currentDateTime.getDate() + 3)

  const scheduleDate = new Date(scheduleDateTime)

  const currentTimeMs = currentDateTime.getTime()
  const scheduleTimeMs = scheduleDate.getTime()
  const threeDaysFromNowMs = threeDaysFromNow.getTime()

  return scheduleTimeMs <= threeDaysFromNowMs && scheduleTimeMs >= currentTimeMs
}

export const isStartDatePassed = (scheduledDate: string) => {
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  const classDate = new Date(scheduledDate)
  classDate.setHours(0, 0, 0, 0)

  return today >= classDate
}

export const getIntakeName = (row: any, handleMoreClick: (row: any) => void) => {
  const intakes = row?.intakes || []

  if (intakes.length === 0) return 'Not Assigned'
  if (intakes.length === 1) return renderIntake(intakes[0].name, row, handleMoreClick)

  const sortedIntakes = intakes.sort((a: any, b: any) => b.isActiveIntake - a.isActiveIntake)

  return renderIntake(`${sortedIntakes[0].name} & ${intakes.length - 1} more`, row, handleMoreClick)
}

const renderIntake = (name: string, row: any, handleMoreClick: (row: any) => void) => (
  <span
    style={{ color: 'green', cursor: 'pointer', textDecoration: 'underline' }}
    onClick={e => {
      e.stopPropagation()
      handleMoreClick(row)
    }}
  >
    {name}
  </span>
)

export const formatDateWithUTC = (item: any) => {
  const formattedDate = moment.utc(item).format('DD MMMM YYYY')

  return formattedDate
}

export const formatDateWithUTCShortMonth = (item: any) => {
  const formattedDate = moment(item).local().format('DD MMM YYYY')

  return formattedDate
}

export const showSubStatusName = (subStatus: any) => {
  return studentApplicationSubStatus[subStatus] ?? subStatus
}

export const toTitleCase = (value: any) => {
  if (typeof value !== "string") return "";
  const str = value.trim();
  if (!str) return "";

  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}